import PropTypes from 'prop-types'
import React from 'react'
import EditIcon from '@mui/icons-material/Edit'
import IconButton from './IconButton'

const EditButton = ({ component = 'Link', text = 'Editar', disabled, ...props }) => {
  return (
    <IconButton text={text} component={component} disabled={disabled} {...props} size="large">
      <EditIcon />
    </IconButton>
  )
}

export default EditButton

EditButton.propTypes = {
  text: PropTypes.string,
  disabled: PropTypes.bool,
  component: PropTypes.oneOf(['a', 'button', 'Link'])
}
